export enum AuthorizationType {
	LICENSED = 'Licensed',
	LIMITED_PERMIT = 'LimitedPermit',
}
